module.exports = __webpack_public_path__ + "img/CloseWhite.b16a2eb6.svg";